import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {
	CustomizerProps,
	ThemeProps,
} from '../../shared/prop-types/ReducerProps';

// Replaced styled-components with plain div to avoid extra dependency
// Note: avoid PureComponent here — it can skip updates when only the
// router location changes and children keep the same element identity.

function MainWrapper({ theme, customizer, children }) {
	const wrapperClass = classNames({
		wrapper: true,
		'squared-corner-theme': customizer.squaredCorners,
		'blocks-with-shadow-theme': customizer.withBoxShadow,
		'top-navigation': customizer.topNavigation,
	});

	return (
		<div className={theme.className} style={{ height: '100vh' }}>
			<div className={wrapperClass}>{children}</div>
		</div>
	);
}

MainWrapper.propTypes = {
	customizer: CustomizerProps.isRequired,
	theme: ThemeProps.isRequired,
	children: PropTypes.node.isRequired,
};

export default connect((state) => ({
	theme: state.theme,
	customizer: state.customizer,
}))(MainWrapper);
